module.exports = __webpack_public_path__ + "img/d_sv1.53ddbd5.png";